// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
  * BreadcrumbSchema - Implements schema.org Breadcrumb
  *
  * Describes a webpage
  *
  * @example
    <BreadcrumbSchema data={data}>
  *
  * @param {array} data.breadcrumbs - Required. The url of the page.
  *
  * @version 0.0.1
  * @todo none
  * @see {@link http://schema.org/breadcrumb|Schema.org Breadcrumb Docs}
  */
var BreadcrumbSchema = function BreadcrumbSchema(props) {
  var data = props.data;


  var schemaOrgJSONLD = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: data.breadcrumbs.map(function (breadcrumb, index) {
      return {
        '@type': 'ListItem',
        position: index,
        item: {
          '@id': breadcrumb.url.substring(0, breadcrumb.url.length - (breadcrumb.url.endsWith('/') ? 1 : 0)),
          name: breadcrumb.name
        }
      };
    })
  };

  return React.createElement(
    Helmet,
    null,
    React.createElement(
      'script',
      { type: 'application/ld+json' },
      JSON.stringify(schemaOrgJSONLD)
    )
  );
};

BreadcrumbSchema.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object // eslint-disable-line react/forbid-prop-types
} : {};

BreadcrumbSchema.defaultProps = {
  data: {
    author: ''
  }

  // ----------------------------------------------------------------------------
  // --------------------------------------------------------------------- Export
  // ----------------------------------------------------------------------------
};export default BreadcrumbSchema;